"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serverShow = serverShow;
exports.clientShow = clientShow;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var Bookmark = _interopRequireWildcard(require("bookmark"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _noty = require("noty");

var _SiteNavigation = _interopRequireWildcard(require("components/SiteNavigation"));

var _contentGroup = babelHelpers.interopRequireDefault(require("block/contentGroup"));

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

var _base = babelHelpers.interopRequireDefault(require("modals/base"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || babelHelpers.typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function serverShow(page, props) {
  return "\n\t\t<div data-product=\"true\">".concat(require('react-dom/server').renderToString( /*#__PURE__*/_react.default.createElement(ProductPage, props)), "</div>\n\t\t").concat(page.inlineScriptArgs(function (props) {
    require('Product').clientShow(this.querySelector('[data-product=true]'), props);
  }, props), "\n\t");
}

function clientShow(node, props) {
  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(ProductPage, props), node);
}

var ProductPage = (_class = /*#__PURE__*/function (_Component) {
  babelHelpers.inherits(ProductPage, _Component);

  var _super2 = _createSuper(ProductPage);

  function ProductPage() {
    var _this2;

    babelHelpers.classCallCheck(this, ProductPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this2, "id", _descriptor, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "images", _descriptor2, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "defaultImage", _descriptor3, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "brandName", _descriptor4, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "title", _descriptor5, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "tagLine", _descriptor6, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "documents", _descriptor7, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "sku", _descriptor8, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "basePrice", _descriptor9, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "salePrice", _descriptor10, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "isFavorite", _descriptor11, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "description", _descriptor12, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "productList", _descriptor13, babelHelpers.assertThisInitialized(_this2));
    _this2.state = {
      quantity: "1",
      addingToCart: false
    };
    _this2._productWrapper = null;
    return _this2;
  }

  babelHelpers.createClass(ProductPage, [{
    key: "showDocument",
    value: function showDocument(event) {
      event.preventDefault();
      var target = event.currentTarget;
      var D = JSON.parse(event.currentTarget.dataset.pdfOptions);
      var tgt;

      if (!D || !D.pdf) {
        tgt = window.open('about:blank', '_blank');
      }

      (0, _fetch.default)("access/".concat(target.dataset.tool, "/").concat(target.dataset.showDocument)).then(function (result) {
        return result.json();
      }).then(function (data) {
        if (data.access == 'enabled') {
          require('trackObjectView').default('catalog', target.dataset.showDocument, true);

          if (tgt) {
            tgt.location.href = data.detail.signedDocumentURL;
          } else {
            var opt = {};
            opt.toolbar = !!D.toolbar;
            opt.file = data.detail.signedDocumentURL;
            opt.controls = Object.keys(D.toolbar).filter(function (v) {
              return D.toolbar[v];
            }).join(",");
            if (data.detail.password) opt.password = data.detail.password;
            var optString = Object.keys(opt).map(function (key) {
              return [key, opt[key]].map(encodeURIComponent).join('=');
            }).join('&');
            var f = document.createElement('div');
            f.id = 'document-viewer-modal-wrap';
            f.className = 'modal-wrapper fade';
            f.innerHTML = "\n\t\t\t\t\t\t<div class=\"modal modal-full modal-full-align-top fade\" id=\"document-viewer-modal\" role=\"dialog\" tabindex=\"-1\" aria-hidden=\"true\" data-backdrop-parent=\"#document-viewer-modal-wrap\">\n\t\t\t\t\t\t\t<div class=\"modal-dialog\">\n\t\t\t\t\t\t\t\t<div class=\"modal-content\">\n\t\t\t\t\t\t\t\t\t<div class=\"modal-header\">\n\t\t\t\t\t\t\t\t\t\t".concat(BLX.modalCloseButton(), "\n\t\t\t\t\t\t\t\t\t\t<h4 class=\"modal-title\">\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"material-icons\" data-icon=\"insert_drive_file\"></span>\n\t\t\t\t\t\t\t\t\t\t\tDocument\n\t\t\t\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"modal-body\">\n\t\t\t\t\t\t\t\t\t\t<iframe id=\"document-viewer\"></iframe>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t");
            f.querySelector('iframe').src = '/admin/platform/plugins/' + target.dataset.corePlugin + '/libraries/pdf.js/web/viewer.html?' + optString;
            document.body.appendChild(f);
            $(f.querySelector('.modal')).on('hidden.bs.modal', function () {
              return $(f).remove();
            }).modal('show');
          }
        } else {
          if (tgt) tgt.close();
          (0, _noty.showNotificationText)("You do not have permission to view that resource.", "danger", "warning");
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "block stack text height-auto color-bg",
        "data-block-type": "productHeader"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "product-detail-header"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "images-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "main-image".concat(this.images.length ? ' clickable' : ''),
        style: {
          backgroundImage: "url(".concat(this.images.length ? this.images[0] : this.defaultImage, ")")
        },
        onClick: this.images.length ? this.showImage : void 0,
        "data-image": this.images[0] || this.defaultImage
      }), this.images.length > 1 && /*#__PURE__*/_react.default.createElement("div", {
        className: "alternate-images"
      }, this.images.slice(1).map(function (image) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "alternate-image",
          style: {
            backgroundImage: "url(".concat(image, ")")
          },
          "data-image": image,
          onClick: _this3.showImage
        });
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "details-container"
      }, this.brandName && /*#__PURE__*/_react.default.createElement("p", {
        className: "brand"
      }, this.brandName), /*#__PURE__*/_react.default.createElement("h1", {
        className: "title"
      }, this.title), this.tagLine && /*#__PURE__*/_react.default.createElement("h3", {
        className: "tagline"
      }, this.tagLine), (this.sku || this.documents.length > 0) && /*#__PURE__*/_react.default.createElement("div", {
        className: "product-id"
      }, this.sku && /*#__PURE__*/_react.default.createElement("p", null, "#", this.sku), this.documents.length > 0 && /*#__PURE__*/_react.default.createElement("p", {
        className: "download"
      }, /*#__PURE__*/_react.default.createElement("a", _extends({
        href: this.documents[0].content[0].link,
        onClick: this.showDocument
      }, this.documents[0].content[0].attributes), /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "description"
      }), ' ', this.documents[0].content[0].title))), /*#__PURE__*/_react.default.createElement("div", {
        className: "pricing-details"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: _classList.default.join('price', this.basePrice != this.salePrice && 'on-sale')
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "base-price"
      }, this.formatPrice(this.basePrice)), this.salePrice != this.basePrice && /*#__PURE__*/_react.default.createElement("span", {
        className: "sale-price"
      }, this.formatPrice(this.salePrice))), /*#__PURE__*/_react.default.createElement("div", {
        className: "add-to-cart"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "number",
        onChange: this.setQuantity,
        value: this.state.quantity,
        className: "form-control",
        disabled: this.state.addingToCart
      }), /*#__PURE__*/_react.default.createElement("button", {
        className: _classList.default.join("btn btn-default", this.state.addingToCart && "spinning"),
        "data-spin": this.state.addingToCart ? 'true' : void 0,
        onClick: this.addToCart
      }, "Add"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "favorite-container"
      }, /*#__PURE__*/_react.default.createElement("a", {
        onClick: this.toggleFavorite,
        href: "javascript:void(0)"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": this.isFavorite ? 'favorite' : 'favorite_border'
      }), this.isFavorite ? 'Remove from ' : 'Add to ', "My Favorites"))))))), this.description && /*#__PURE__*/_react.default.createElement("div", {
        className: "block stack text height-auto white-bg",
        "data-block-type": "productDetails"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content container",
        dangerouslySetInnerHTML: {
          __html: this.description.indexOf('<') == -1 ? "<p>".concat(this.description, "</p>") : this.description
        }
      })), this.documents.map(function (group) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "block stack text height-auto white-bg",
          "data-block-type": "productDocuments",
          "data-block-id": group.id
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "inner-content container"
        }, /*#__PURE__*/_react.default.createElement("h5", null, group.header), group.content.map(function (item) {
          return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", _extends({
            onClick: _this3.showDocument,
            href: item.link
          }, item.attributes), /*#__PURE__*/_react.default.createElement("span", {
            className: "material-icons",
            "data-icon": "description"
          }), ' ', item.title));
        })));
      }), this.productList && /*#__PURE__*/_react.default.createElement("div", {
        className: "block stack block-container height-auto",
        "data-block-type": "container"
      }, /*#__PURE__*/_react.default.createElement(_contentGroup.default, {
        showButton: false,
        groupLink: null,
        promoButtonText: "",
        resourceGroups: null,
        hideTitle: false,
        titleColor: "",
        title: this.productList.title,
        customHeader: null,
        displayMode: "card",
        content: this.productList.items,
        asCarousel: false,
        className: "stack",
        id: "relatedProductList",
        block_type: "contentGroup",
        child_type: "block/contentGroup"
      })));
    }
  }, {
    key: "setQuantity",
    value: function setQuantity(event) {
      this.setState({
        quantity: event.target.value.replace(/[^0-9]/g, "")
      });
    }
  }, {
    key: "profileUpdated",
    value: function profileUpdated() {}
  }, {
    key: "toggleFavorite",
    value: function toggleFavorite() {
      var _this4 = this;

      Bookmark.toggle().then(function () {
        return _this4.profileUpdated();
      });
    }
  }, {
    key: "addToCart",
    value: function addToCart() {
      var _this5 = this;

      if (this.state.addingToCart || isNaN(Number(this.state.quantity)) || Number(this.state.quantity) == 0) return;
      this.setState({
        addingToCart: true
      }, function () {
        (0, _fetch.default)("data/cart/add", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            product: _this5.id,
            quantity: Number(_this5.state.quantity)
          })
        }).then(function (v) {
          return v.json();
        }).then(function (v) {
          _SiteLayout.default.current.maybeGoBack("catalog/PRODUCTS", "catalog/PRODUCTS/Frequently-Ordered").then(function () {
            (0, _noty.showNotificationText)('Added "' + _this5.title + '".'); // this.setState({ addingToCart: false, quantity: 1 });

            _SiteNavigation.ClientSelect.current.fetchCart();

            _SiteNavigation.default.cartUpdated();
          });
        });
      });
    }
  }, {
    key: "formatPrice",
    value: function formatPrice(amount) {
      amount = Number(amount).toFixed(2);

      var _amount$split = amount.split('.'),
          _amount$split2 = babelHelpers.slicedToArray(_amount$split, 2),
          whole = _amount$split2[0],
          dec = _amount$split2[1];

      var dd = '';

      while (whole.length > 3) {
        dd = ",".concat(whole.substr(-3));
        whole = whole.substring(0, whole.length - 3);
      }

      dd = whole + dd;
      return "$".concat(dd, ".").concat(dec);
    }
  }, {
    key: "showImage",
    value: function showImage(_ref) {
      var image = _ref.target.dataset.image;
      new ImageViewer(image).show();
    }
  }]);
  return ProductPage;
}(_react.Component), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "images", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "defaultImage", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "brandName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "tagLine", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "documents", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "sku", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "basePrice", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "salePrice", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "isFavorite", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "description", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "productList", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "showDocument", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "showDocument"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setQuantity", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setQuantity"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "toggleFavorite", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "toggleFavorite"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "addToCart", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "addToCart"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "showImage", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "showImage"), _class.prototype)), _class);
exports.default = ProductPage;

var ImageViewer = /*#__PURE__*/function (_Modal) {
  babelHelpers.inherits(ImageViewer, _Modal);

  var _super = _createSuper(ImageViewer);

  function ImageViewer(image) {
    var _this;

    babelHelpers.classCallCheck(this, ImageViewer);
    _this = _super.call(this, 'imageViewer');
    _this.removeOnHide = true;
    _this.hasModalTitleElement = false;
    _this.innerWrapper = false;
    _this.image = image;
    return _this;
  }

  babelHelpers.createClass(ImageViewer, [{
    key: "title",
    get: function get() {
      return "";
    }
  }, {
    key: "getModalContent",
    value: function getModalContent() {
      return Promise.resolve("\n\t\t\t<div class='container' style='position: relative; height: 100%; max-width: 100%; width: auto; padding-bottom: 25px; display: flex; flex-direction: column; align-items: stretch; justify-content: stretch;'>\n\t\t\t\t<div style=\"background-image: url(".concat(this.image, "); background-size: contain; background-position: 50% 50%; background-repeat: no-repeat; flex: 1 1 auto;\"></div>\n\t\t\t</div>\n\t\t"));
    }
  }]);
  return ImageViewer;
}(_base.default);